export enum GenericCommentObjectType {
	blog = 1,
	engagementGoal = 2,
	engagementActivity = 3,
	engagementProgress = 4,
	engagementToDo = 5,
	mediabank = 6,
	standalone = 7,
	engageObject = 8,
	event = 9,
	documentFeedback = 20,
	documentFeedbackNotes = 21,
	task = 30,
}

export type GenericComment = {
	Id: number;
	Comment: string;
	ParentId?: number;
	Date?: string;
	ParsedDate?: Date;
	UserId?: number;
	AuthorName?: string;
	ObjectType: GenericCommentObjectType;
	ObjectId?: number;
};
